import { useCallback, useMemo, useState } from 'react';
import PaymentsPopup from '../Payments/PaymentsPopup';
import { getString } from '../../../strings';
import { StyledText } from '../../atoms/Text/StyledText';
import { StyledButton } from '../../atoms/Button/StyledButton';
import { BigLoader, StyledBigLoader } from '../../atoms/Loader/StyledBigLoader';
import { syncRegistrations } from '../../../logic/requests/events';

const SyncRegistrationsModal = ({ eventData, onClose }) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [queryFinished, setQueryFinished] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = useCallback(() => {
        setIsLoading(true);
        syncRegistrations(eventData.id)
            .then(
                (res) => {
                    setData(res);
                    setError(null);
                },
                (err) => {
                    setError(err);
                    console.log(err);
                }
            )
            .finally(() => {
                setQueryFinished(true);
                setIsLoading(false);
            });
    }, [eventData]);

    const renderContent = useMemo(
        () =>
            queryFinished ? (
                <div>
                    {error ? (
                        <>
                        <StyledText
                            hasdeclaredfontsize="20px"
                            hasdeclaredpadding={'50px 20px 20px 20px'}
                            hasdeclaredlineheight="1.4em"
                            hasdeclaredtextalign="center"
                            hasdeclaredfontcolor="#EE745C"
                            hasdeclaredfontweight="600"
                        >
                            {getString('userPanel_userPanelTournament_sync_registrations_error')}
                        </StyledText>
                        <StyledText
                            hasdeclaredfontsize="18px"
                            hasdeclaredpadding={'20px 20px 20px 20px'}
                            hasdeclaredlineheight="1.4em"
                            hasdeclaredtextalign="center"
                        >
                            {error.data.message}
                        </StyledText>
                        </>
                    ) : (
                        <StyledText
                            hasdeclaredfontsize="18px"
                            hasdeclaredpadding={'50px 20px 20px 20px'}
                            hasdeclaredlineheight="1.4em"
                            hasdeclaredtextalign="center"
                        >
                            {getString('userPanel_userPanelTournament_sync_registrations_success')}
                        </StyledText>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#6d85ba"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 0 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            hasdeclaredtexttransform="uppercase"
                            onClick={onClose}
                        >
                            {getString('all_trainer_pay_popup_zamknij')}
                        </StyledButton>
                    </div>
                </div>
            ) : isLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <BigLoader />
                </div>
            ) : (
                <>
                    <StyledText
                        hasdeclaredfontsize="18px"
                        hasdeclaredpadding={'40px 20px 20px 20px'}
                        hasdeclaredlineheight="1.4em"
                        hasdeclaredtextalign="center"
                    >
                        {getString('userPanel_userPanelTournament_sync_registrations')}
                    </StyledText>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#6d85ba"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 0 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            hasdeclaredtexttransform="uppercase"
                            onClick={onSubmit}
                        >
                            {getString('userPanel_userPanelTournament_sync_registrations_confirm')}
                        </StyledButton>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#ee745c"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 40px 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            onClick={onClose}
                        >
                            {getString('userPanel_userPanelTournament_payment_reminder_cancel')}
                        </StyledButton>
                    </div>
                </>
            ),
        [onClose, isLoading, onSubmit]
    );

    return <PaymentsPopup>{renderContent}</PaymentsPopup>;
};

export default SyncRegistrationsModal;
